import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { useTranslation } from 'react-i18next';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { useMergeRefs } from '@/js/libs/hooks/useMergeRefs/index.ts';
import { memoGeneric } from '@/js/libs/memo/index.ts';
import { InputRenderer, FormField, isErrorVisible } from '@/js/libs/ui/src/V2/index.ts';
import { useController } from '../hooks/index.js';
export const TextField = memoGeneric(function TextField({ control, name, disabled, renderError, label, labelTooltip, required, iconStart, iconEnd, width, withTouched = false, onChange: onChangeProp, onBlur: onBlurProp, trimValue = false, warningMessage, fieldPlaceholder, inputRef, ...restProps }) {
    const [t] = useTranslation(['backend', 'common']);
    const { field: { onChange, value: nonUndefinedValue = '', onBlur, ref: fieldRef, ...restField }, fieldState, } = useController({ control, name });
    const mergedRefs = useMergeRefs(fieldRef, inputRef);
    const { isTouched, error } = fieldState;
    const handleChange = useCallbackRef((e) => {
        onChangeProp?.(e);
        if (!e.defaultPrevented) {
            onChange(trimValue ? e.target.value.trim() : e.target.value);
        }
    });
    const handleBlur = useCallbackRef((event) => {
        onBlur();
        onBlurProp?.(event);
    });
    return (_jsx(FormField, { fieldPlaceholder: fieldPlaceholder, disabled: disabled, error: error?.message, label: label, labelTooltip: labelTooltip, name: name, renderError: renderError, required: required, touched: isTouched, warningMessage: warningMessage, withTouched: withTouched, children: _jsx(InputRenderer, { disabled: disabled, error: isErrorVisible(error?.message, isTouched, withTouched), iconEnd: iconEnd, iconStart: iconStart, width: width, onChange: handleChange, placeholder: t('common:ENTER'), warning: !!warningMessage, ...restProps, ...restField, ref: mergedRefs, value: nonUndefinedValue, onBlur: handleBlur }) }));
});
